var stickybits = require('stickybits/dist/stickybits.min.js');

$(document).ready( function() {

	///************  MAIN NAV SUBMENU *************///

	$('.menu .menu__item.menu__item--has-children .submenu__toggle').click( function(evt) {
		evt.preventDefault();
		if( $(this).siblings('.menu__submenu').hasClass('open') ) {
			$(this).siblings('.menu__submenu').removeClass('open');
		} else {
			$('.menu__submenu.open').removeClass('open');
			$(this).siblings('.menu__submenu').addClass('open');
		}
	});


	///*************  ALERT PANEL TOGGLE ************///

	$('.menu__workpanels .worknav__item--alerts .submenu__toggle').click(function(evt) {
		evt.preventDefault();
		$('.panel__item').removeClass('active');
		$('.worknav__panels').removeClass('active');
		$(this).closest('.worknav__item').toggleClass('active');
		$('.worknav__panel__alert').toggleClass('open');
	});


	///*************** 	LANDING PAGE PANELS ***************///

	// Get height of largest worknav__panel
	var panelHeights = $('.worknav__panel').map(function() {
		return $(this).outerHeight();
	}).get();
	var maxHeight = Math.max.apply(null, panelHeights);

	// Set panel inner and panels to be height of max
	$('.worknav__panels__inner, .worknav__panel').height(maxHeight + 'px');



	/// TOGGLES ************///

	// Toggle worknav panels on click
	$('.menu__workpanels .worknav__item.panel__item .submenu__toggle').click( function(evt) {
		evt.preventDefault();

		// Check if alert panel is open
		$('.worknav__panel__alert').removeClass('open');

		panelNum = $(this).attr('data-id');
		currentNav = $('.menu__workpanels .worknav__item--' + panelNum);
		currentPanel = $('.worknav__panel.panel_' + panelNum);

		//** PANELS HOLDER
		if( currentNav.hasClass('active') && currentPanel.hasClass('active') ) {
			$('.worknav__panels').removeClass('active');
		} else {			
			$('.worknav__panels').addClass('active');
		}

		//** NAV ITEM
		if( currentNav.hasClass('active') ) {
			$('.worknav__item').removeClass('active');
		} else {
			$('.worknav__item').removeClass('active');
			currentNav.addClass('active');
		}

		//** CURRENT PANEL
		if( currentPanel.hasClass('active') ) {
			// Closing current panel
			$('.worknav__panel').removeClass('active').css('z-index', 3);

		} else {
			// Swapping panels 
			$('.worknav__panel').removeClass('active').animate({ 
				'opacity': 0
			}, { 
				duration: 500, 
				queue: false
			}).css('z-index', 3);
			currentPanel.addClass('active').css('z-index', 4).animate({
				'opacity': 1
			}, {
				duration: 500, 
				queue: false
			});
		}

	});



	$('.worknav__item').hover( function() {
		$(this).toggleClass('hovering');
	});


	///*********** SIDEBAR MENU TOGGLES *****//

	$('.sidebar__menu__toggle').click(function(evt) {
		evt.preventDefault();
		$(this).toggleClass('rotate');
		var menu = $(this).siblings('.menu__second');

		if( menu.hasClass('open') ) {
			menu.removeClass('open').slideToggle('hide');
		} else {
			menu.addClass('open').slideToggle('open');
		}

	});

	$('.siderbar-mobile__toggle, .siderbar-mobile__menu-toggle').click(function(evt) {
		evt.preventDefault();
		$('.sidebar__left').toggleClass('sidebar__left--nav-open');
		$('body').toggleClass('modal-open');
		$('html').toggleClass('modal-open');
		//$('body').css('overflow-y','auto');
	});

	stickybits(".siderbar-mobile__toggle", { stickyBitStickyOffset: 100,  useFixed: true });

	///************ HAMBURGLAR RESPONSIVE MENU TOGGLE *****//
	var header = $('body:not(.online-form) header');
	var workPanels = $('.menu__workpanels');
	var menuPanel = $('.menu__panel');
	var globalAlert = $('.global-alert');
	var noticeMessage = $('.notice-message');
	var moreInfo = globalAlert.find('.more');
	
	$('.hamburglar').click(function() {
		$(this).toggleClass('open');
		$('.menu__panel').slideToggle();
		$(document).find('html').toggleClass('no-scroll');

		if ($(this).hasClass('open')) {
			header.addClass('sticky');
			menuPanel.addClass('sticky');
			workPanels.slideUp();
			globalAlert.css('min-height', 'auto');
			globalAlert.css('height', '70px');
			globalAlert.slideUp();
			noticeMessage.slideUp();
			globalAlert.removeClass('global-alert--expanded');
			moreInfo.html('<p>More Information</p><span></span>');
			moreInfo.children('span').css('transform', 'rotate(90deg)');
		} else {
			header.removeClass('sticky');
			menuPanel.removeClass('sticky');
			workPanels.slideDown();
			if (!globalAlert.hasClass('closed')) {
				globalAlert.slideDown();
			}
		}
	});

	$('.menu__responsive .worknav .submenu__toggle').click(function(evt) {
		evt.preventDefault();

		currentToggle = $(this);

		if( $(this).next('.worknav__item__submenu').hasClass('open') ) {
			$(this).next('.worknav__item__submenu').removeClass('open');
			currentToggle.removeClass('open');
		} else {
			$(this).next('.worknav__item__submenu.open').removeClass('open');
			$(this).next('.worknav__item__submenu').addClass('open');
			currentToggle.addClass('open');
		}
	});


	///************ STICKY NAV HEIGHT ON SCROLL *****//

	var distance = 80;
	var $window = $(window);
	var body = $('body');
	var header = $('body:not(.online-form) header');
	var workPanels = $('.menu__workpanels');
	var menuPanel = $('.menu__panel');
	var siteNotice = $('.site-notice');
	var globalAlerts = $('.menu__alertswrapper');
	var globalAlert = $('.global-alert');
	var mobileMenuTrigger = $('.mobile-menu-trigger');
	var moreInfo = globalAlert.find('.more');
	var headerBackdrop = $('.header-backdrop');

	
	// add the ehight of siteNotice to the distance
	if (siteNotice.length) {
		distance += siteNotice.height();
	}

	var siteNoticeTransitioning = false;

	// if scroll position is inside the distance, set shouldCloseSiteNoticeNext to true. otherwise set it to false.
	// if ($window.scrollTop() >= distance) {
	// 	console.log('shouldCloseSiteNoticeNext = false')
	// 	shouldCloseSiteNoticeNext = false;
	// } else {
	// 	console.log('shouldCloseSiteNoticeNext = true')
	// 	shouldCloseSiteNoticeNext = true;
	// }

	body.css('paddingTop', header.height());

	headerBackdropHeight = header.height() + 500;

	headerBackdrop.css('height', header.height());

	$window.on('resize', function(){
		body.css('paddingTop', header.height());
	});

	var scrollDistanceTrigger = distance;

	// Initialize lastScrollTop variable before $window.scroll
	let lastScrollTop = 0;

	$window.scroll(function () {
		var st = $(this).scrollTop();

		if (!mobileMenuTrigger.hasClass('open')) {
			if (st >= scrollDistanceTrigger) {
				header.addClass('sticky');
				menuPanel.addClass('sticky');

				// New logic for handling site notice based on scroll direction
				if (st > lastScrollTop) {
					// Scrolling down
					if (!siteNoticeTransitioning && siteNotice.is(':visible')) {
						siteNoticeTransitioning = true;
						header.attr('data-top', header.css('top'));
						header.animate({
							top: 0
						}, {
							duration: 400,
							complete: function() {
								siteNoticeTransitioning = false;
							}
						});
						siteNotice.slideUp(400);
					}
				} else {
					// Scrolling up
					if (!siteNoticeTransitioning && !siteNotice.is(':visible')) {
						siteNoticeTransitioning = true;
						header.animate({
							top: header.attr('data-top')
						}, {
							duration: 400,
							complete: function() {
								siteNoticeTransitioning = false;
							}
						});
						siteNotice.slideDown(400, function () {
							globalAlerts.css('margin-top', siteNotice.height());
						});
					}
				}

				workPanels.slideUp(400, function() {
					var height = header.height();
					if (!window.matchMedia('(max-width: 568px)').matches) {
						height += 80;
					}
					
					var globalAlertsHeight = globalAlerts.height();
					if(globalAlerts.length){
						height += globalAlertsHeight;
					}
				});

				globalAlert.each(function() {
					$(this).find('.notice-message').slideUp();
					$(this).removeClass('global-alert--expanded');
				});

				moreInfo.html('<p>More Information</p><span></span>');
				moreInfo.children('span').css('transform', 'rotate(90deg)');

			} else {
				header.removeClass('sticky');
				menuPanel.removeClass('sticky');

				siteNotice.slideDown(400, function() {
					header.css('top', siteNotice.height());
				});
				
				workPanels.slideDown(400, function() {
					body.css('paddingTop', header.height());
				});
			}
		}

		// Update lastScrollTop for the next scroll event
		lastScrollTop = st;
	});


	// if this is larger than distance then display none
	$('.hamburglar').click(function() {
		if (!$(this).hasClass('open')) {
			if ($window.scrollTop() >= distance) {
				globalAlert.hide();
				globalAlert.removeClass('global-alert--expanded');
			}
		}
	});


	///************ SHIFT ANCHOR POSITION TO ACCOUNT FOR STICKY NAV *****//

	if(window.location.hash) {
		var headerHeight;
		var id = window.location.hash.substring(1);

		if (header.hasClass('sticky')) {
			if ($(window).width() > 568) {
				headerHeight = 174;
			} else {
				headerHeight = 94;
			}
		} else {
			if ($(window).width() > 1024) {
				headerHeight = 71;
			} else {
				headerHeight = 94;
			}
		}

		var offset = $('#' + id).offset();
		var scrollto = offset.top - headerHeight;
		$('html, body').animate({scrollTop:scrollto}, 0);
	}

	// =====================================================================
	// Fix for mobile menu not closing when clicking anchor links

	$('.menu__responsive .worknav__item__link').click(function(evt) {
		var anchor = $(this).attr("href");
		var targetPage = anchor.split("#")[0];
		var currentPage = window.location.pathname;

		// Check if we're on the page the link links to
		if (currentPage === targetPage) {
			evt.preventDefault();

			var targetId = anchor.split('#')[1];
			var target = $('.page__content').find('#' + targetId);

			var headerHeight = header.height();
			var scrollPosition = target.offset().top - headerHeight;

			$('html, body').animate({
				scrollTop: scrollPosition
			}, 1000);

			$('.hamburglar').removeClass('open');
			$('.menu__panel').slideUp();
			$(document).find('html').removeClass('no-scroll');
		}
	});
});